import { Flex, Title } from '@wyz/ui';
import * as React from 'react';
type Props = {
  title: React.ReactNode;
  subtitle: React.ReactNode;
};

export function NoActions({ title, subtitle }: Props) {
  return (
    <Flex direction='column' alignItems='center'>
      <SvgImage />
      <Title heading='xl' weight='bold' color='tertiary' className='mt-5 mb-1'>
        {title}
      </Title>
      <Title heading='lg' weight='normal' color='secondary' className='mb-4'>
        {subtitle}
      </Title>
    </Flex>
  );
}

function SvgImage() {
  return (
    <svg
      width='400'
      height='300'
      viewBox='0 0 580 401'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M155.04 242.809L157.804 211.796C157.816 211.674 157.725 211.565 157.603 211.555C157.481 211.543 157.373 211.634 157.362 211.757L154.598 242.769C154.586 242.891 154.677 242.999 154.799 243.011C154.921 243.021 155.029 242.931 155.04 242.809Z'
        fill='#D8D7D5'
      />
      <path
        d='M173.677 254.868L137.633 268.239C137.518 268.283 137.459 268.411 137.502 268.527C137.545 268.642 137.671 268.701 137.787 268.658L173.832 255.287C173.946 255.244 174.005 255.115 173.963 255C173.921 254.885 173.793 254.825 173.677 254.868Z'
        fill='#D8D7D5'
      />
      <path
        d='M189.223 271.016L193.861 247.503C193.885 247.383 193.807 247.265 193.686 247.241C193.566 247.217 193.449 247.296 193.425 247.416L188.788 270.929C188.764 271.049 188.842 271.167 188.962 271.191C189.083 271.215 189.199 271.136 189.223 271.016Z'
        fill='#D8D7D5'
      />
      <path
        d='M346.155 339.18H219.035L231.277 254.776H333.912L346.155 339.18Z'
        fill='#C4CED9'
      />
      <path
        d='M440.648 269.66H124.542C116.51 269.66 110 263.123 110 255.059V55.1007C110 47.0367 116.51 40.4994 124.542 40.4994H440.648C448.679 40.4994 455.19 47.0367 455.19 55.1007V255.059C455.19 263.123 448.679 269.66 440.648 269.66Z'
        fill='#DAE0E7'
      />
      <path
        d='M431.896 245.5H132.542C124.51 245.5 118 238.963 118 230.899V61.8825C118 53.8184 124.51 47.2812 132.542 47.2812H431.896C439.928 47.2812 446.438 53.8184 446.438 61.8825V230.899C446.438 238.963 439.928 245.5 431.896 245.5Z'
        fill='#C4CED9'
      />
      <path
        d='M373.098 345.328H192.092V336.548C192.092 329.76 197.573 324.257 204.333 324.257H360.856C367.618 324.257 373.098 329.76 373.098 336.548V345.328Z'
        fill='#DAE0E7'
      />
      <path
        d='M286.603 258.382C286.603 262.287 283.449 265.453 279.559 265.453C275.669 265.453 272.517 262.287 272.517 258.382C272.517 254.476 275.669 251.309 279.559 251.309C283.449 251.309 286.603 254.476 286.603 258.382Z'
        fill='#B8C4D1'
      />
      <path
        d='M311.688 100.5L282.999 129.189L254.312 100.502L237 117.812L265.687 146.501L237 175.188L254.312 192.5L282.999 163.813L311.688 192.5L329 175.189L300.311 146.501L329 117.812L311.688 100.5Z'
        fill='#A5B4C5'
      />
      <path
        d='M415.215 306.371C403.205 306.371 391.188 301.823 381.945 292.702C375.309 286.153 370.995 278.129 369.013 269.66H369.024C369.042 269.739 369.061 269.82 369.08 269.9L369.772 269.66H387.63L370.795 275.506C372.396 279.783 374.628 283.871 377.493 287.63L429.235 269.66H440.648C446.535 269.66 451.604 266.147 453.892 261.096L462.675 258.045C462.611 253.42 461.879 248.806 460.485 244.357L455.189 246.196V239.994L458.386 238.883C457.467 236.865 456.403 234.898 455.189 232.999V232.983C466.904 251.295 464.907 275.939 449.073 292.117C439.78 301.611 427.501 306.371 415.215 306.371Z'
        fill='#FAFEFF'
      />
      <path
        d='M377.493 287.629C374.628 283.871 372.396 279.782 370.795 275.505L387.63 269.659H429.235L377.493 287.629ZM453.892 261.095C454.725 259.255 455.19 257.211 455.19 255.058V246.195L460.485 244.356C461.879 248.806 462.612 253.42 462.675 258.044L453.892 261.095Z'
        fill='#FEFFFF'
      />
      <path
        d='M369.08 269.898C369.061 269.818 369.042 269.738 369.024 269.658H369.772L369.08 269.898ZM455.19 239.992V232.997C456.403 234.897 457.467 236.864 458.386 238.882L455.19 239.992Z'
        fill='#FEFFFF'
      />
      <ellipse
        opacity='0.6'
        cx='414.988'
        cy='259.177'
        rx='47.9068'
        ry='48.103'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M318.753 340.451C314.208 345.094 314.273 352.558 318.897 357.12C323.52 361.684 330.953 361.618 335.498 356.976L386.075 305.302C407.397 318.777 435.907 316.048 454.289 297.266C475.497 275.599 475.196 240.772 453.616 219.478C432.038 198.184 397.352 198.486 376.145 220.153C357.762 238.936 355.54 267.605 369.33 288.778L318.753 340.451ZM383.04 226.958C365.575 244.801 365.823 273.483 383.594 291.019C401.365 308.555 429.93 308.307 447.395 290.463C464.859 272.618 464.611 243.938 446.841 226.401C429.07 208.865 400.505 209.114 383.04 226.958Z'
        fill='#A5B4C5'
      />
    </svg>
  );
}
